import firebase from 'firebase';

export const getCampusGroups = firebase.functions().httpsCallable('getCampusGroups');
export const saveCampusGroup = firebase.functions().httpsCallable('saveCampusGroup');
export const deleteCampusGroup = firebase.functions().httpsCallable('deleteCampusGroup');

export default 'CampusGroups.api.js';
